

import { computed, defineComponent, onMounted, ref } from 'vue';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import Dropdown from 'primevue/dropdown';
import CatalogTypeConst from '../../../../../catalog/domain/const/CatalogTypeConst';
import helperCatalog from '../../../../../catalog/infrastructure/helper/helperCatalog';
import { Container } from 'inversify';
import { IServiceSearch } from '../../../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../../../common/domain/types';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import CatalogDbType from '../../../../../catalog/domain/const/CatalogDbType';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';

import CatalogObjectTypeConst from '../../../../../catalog/domain/const/CatalogObjectTypeConst';
import { ProcedureData } from '../../../../../search/domain/procedureData';
import { IServiceComponent } from '../../../../../component/application/IServiceComponent';
import { IapComponent } from '../../../../../component/domain/iapComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import CatalogAttrConst from '../../../../../catalog/domain/const/CatalogAttrConst';
import HelperCustomComponentControls from '../../../functions/helperCustomComponentControls';
import DisplayComponentNodeConst from '../constants/DisplayComponentNodeConst';

export default defineComponent({
    name: 'custommodalcomponentcontrol',

    props: {
        data: Object
    },
    setup(props) {

        const selectedComponentHeader = ref('');
        const selectedComponent = ref(-1);
        const selectedComponentModalInput = ref(false);
        //const datacatalog = helperCatalog.getAllCatalogApp();
        const dtComponentsInfo = ref<IapComponent[]>([]);
        const dtComponentsVarInfo = ref<IapComponentAttribute[]>([]);
        const { showExpression } = HelperCustomComponentControls(props.data);

        /*
        const connectionData = computed(() => {
            return datacatalog.filter(x => x.id == CatalogTypeConst.TIPOBD)?.find(x => x !== undefined)?.iapCatalogs.sort((a, b) => { return (a.order ?? 0) - (b.order ?? 0); });
        })
        */

        const getComponentNames = computed(() => {
            const aux = dtComponentsInfo.value.map((x: IapComponent) => ({ id: x?.id, description: x?.name }))
            return aux.filter((a, i) => aux.findIndex((s) => a.id === s.id) === i)
        })

        const getComponentVariables = computed(() => {
            return dtComponentsVarInfo.value.map(x => ({ id: x.id, name: x.name, value: x.value, idAttributeType: x.idAttributeType }));
        })


        const changeComponent = () => {
            if (props.data) {
                getComponentAttributes(selectedComponent.value).then(response => {
                    if (response && props.data) {
                        selectedComponentHeader.value = "";
                        props.data.onChange({ key: DisplayComponentNodeConst.VAR_HEADER_IN, data: selectedComponentHeader.value })
                        props.data.onChange({ key: DisplayComponentNodeConst.VAR_COMP_IN, data: selectedComponent.value })
                        props.data.onChange({ key: DisplayComponentNodeConst.VAR_COMPMODAL_IN, data: selectedComponentModalInput.value })
                        props.data.onChange({ key: DisplayComponentNodeConst.VAR_PARAM_IN, data: getComponentVariables.value })
                    }

                });

            }
        }

        const changeComponentModal = () => {
            if (props.data) {
                props.data.onChange({ key: DisplayComponentNodeConst.VAR_COMPMODAL_IN, data: selectedComponentModalInput.value })
            }
        }


        const changeComponentHeader = () => {
            if (props.data) {
                props.data.onChange({ key: DisplayComponentNodeConst.VAR_HEADER_IN, data: selectedComponentHeader.value })
            }
        }


        const changeProcedureName = () => {
            if (props.data) {
                dtComponentsVarInfo.value = getComponentVariables.value as any;
                props.data.onChange({ key: DisplayComponentNodeConst.VAR_PARAM_IN, data: getComponentVariables.value })
            }

        }

        const changeVariableValue = () => {
            alert('change variable')
            if (props.data) {
                props.data.onChange({ key: DisplayComponentNodeConst.VAR_PARAM_IN, data: getComponentVariables.value })
            }

        }

        const loadComponentsParent = () => {
            if (props.data && props.data.container) {
                HelperLoading.showLoading()
                const _srv = (props.data.container as Container).get<IServiceComponent>(TYPES.COMPONENT_REPOSITORY)

                _srv.getParents(props.data.applicationId ?? -1, props.data.applicationVersion ?? -1).then((response: IapComponent[]) => {
                    dtComponentsInfo.value = response;

                })
                    .finally(() => {
                        HelperLoading.hideLoading()
                    })
            }
        }



        const getComponentAttributes = async (componentId: number, setInitData: boolean = false): Promise<boolean> => {


            return await new Promise<boolean>((resolve, reject) => {

                if (componentId > 0 && props.data && props.data.container) {
                    HelperLoading.showLoading()
                    const _srv = (props.data.container as Container).get<IServiceComponent>(TYPES.COMPONENT_REPOSITORY)

                    _srv.getById(componentId).then((response: IapComponent) => {
                        dtComponentsVarInfo.value = response.iapComponentAttributes.filter(x => x.idAttributeType == CatalogAttrConst.TIPOATTR_PROPCUS);

                        if (setInitData && props.data) {
                            (props.data.variableComponentParametersInput as IapComponentAttribute[]).forEach(x => {
                                const item = dtComponentsVarInfo.value.find(y => y.id == x.id)
                                if (item) {
                                    item.value = x.value
                                }
                            })

                        }
                    })
                        .finally(() => {
                            HelperLoading.hideLoading()
                            resolve(true)
                        })
                }


            });


        };






        onMounted(() => {
            loadComponentsParent();

            if (props.data) {

                selectedComponentHeader.value = props.data.variableComponentHeaderInput
                selectedComponent.value = props.data.variableComponentInput
                selectedComponentModalInput.value = props.data.variableComponentModalInput
                dtComponentsVarInfo.value = props.data.variableComponentParametersInput as IapComponentAttribute[]

                if (selectedComponent.value) {
                    getComponentAttributes(selectedComponent.value, true);
                }
            }

        })

        return {
            selectedComponent,
            selectedComponentModalInput,
            selectedComponentHeader,
            changeComponent,
            changeProcedureName,
            dtComponentsInfo,
            getComponentNames,
            getComponentVariables,
            changeVariableValue,
            CatalogObjectTypeConst,
            showExpression,
            dtComponentsVarInfo,
            changeComponentModal,
            changeComponentHeader,
            DisplayComponentNodeConst
        };
    },
});
